import { B } from "mockjs";

export enum ResCode {
  SUCCESS = 0,
  BILLCHANGEONCE = 1139,
}

/**
 * 操作类型
 *
 * @enum {number}
 */
export enum ActionType {
  ANY = 0,
  GET = 1,
  POST = 2,
}

export enum ReqMethodType {
  GET = 'get',
  POST = 'post',
}


/**
 * 权限类型，
 *
 * @export
 * @enum {number}
 */
export enum PermissionType {
  BACKEND = 0,            // 后端权限，控制api的访问
  FRONT = 1,              // 前端权限，控制前端的展示
}


/**
 *  只需要结果API返回值
 *
 * @interface CommonResponse
 */
export interface CommonResponse {
  code?: ResCode;
  Code?: ResCode;
  msg?: string;
  Msg?: string;
}


/**
 * 权限列表
 *
 * @export
 * @interface Permissions
 */
export interface RolePermissions {
  key: string;
  name: string;
  desc: string;
  permissions: Permission[];
}


/**
 * 权限显示
 *
 * @export
 * @interface Prmission
 */
export interface Permission {
  path: string;                     // 权限路径
  action: ActionType;                   // 操作动作，比如后端权限的
}
/**
 * 后端路由定义
 *
 * @export
 * @interface BackendRoute
 */
export interface BackendRoute {
  path: string;                     // 权限路径
  method: ReqMethodType;                   // 操作动作，比如后端权限的
}


/**
 * 类型转换
 *
 * @export
 * @param {ReqMethodType} method
 * @returns
 */
export function MethodToAction(method: ReqMethodType) {

  switch (method) {
    case ReqMethodType.GET:
      return ActionType.GET;
    case ReqMethodType.POST:
      return ActionType.POST;
    default:
      return ActionType.ANY;
  }
}


export interface PagingReq {
  page: number;
  pageSize: number;
}

export interface MeterType {
  id: number;         // 数据库ID
  name: string;       // meterTypeName
  meterCount: number;
}

export interface SubMeterType {
  index: number,
  lable: string,
}


export interface Admin {
  id: number;
  email: string;      // email
  userName: string;   // 用户名
  portrait: string;   // 头像
  phone: string;      // 手机
  deleteState: number;
  position: string;
  frontRole: string;
  backRole: string;
  companyID: number;
  companyName: string;
  password: string;           // 创建者密码
  confirmPassword: string;    // 创建者密码确认
  language: string;
}


export interface User {
  id: number;
  userName: string;
  deleteState: number;
  email: string;      // email
  userID: string;     // userID
  portrait: string;   // 头像
  address: string;    // 地址
  createTime: string; // 创建时间
  password: string;
  confirmPassword: string;
  companyName: string;
  companyID: number;
}
export interface PagingResData {
  curPage: number;
  totalPage: number;
  totalCount: number;
  nextPage: number;
}
export interface MeterCost {
  id: number;              // 数据库ID
  name: string;
  level: number;           // 0 代表上级  1 代表next计费规则
  updateDate: string;      // 更新日期
  nextMeterCost: MeterCost;
  usageType: number;
  meterTypeID: number;
  meterTypeName: string;
  holidayName: string;
  holidayID: number;
  moneyUnit: string;
  normalRule: string;
  saturdayRule: string;
  sundayRule: string;
  HolidayRule: string;
  normalRuleS: RuleCost[];
  saturdayRuleS: RuleCost[];
  sundayRuleS: RuleCost[];
  holidayRuleS: RuleCost[];
  companyName: string;
  companyID: number;
}

export interface RuleCost {
  id: number;
  startTime: string;
  endTime: string;
  startUsage: number;
  endUsage: number;
  usageType: number;
  cost: number;
}
export interface HolidayDate {
  id: number;
  name: string;
  dates: string;
  tempDates: Date[];
  companyName: string;
  companyID: number;
}

export interface Operation {
  id: number;
  time: number;
  date: string;
  action: string;      // 动作
  describe: string;
  companyName: string;
  companyID: number;
  admin: string;       // 操作人
  adminID: number;
}
export interface MeterFault {
  meterFaultsID: number;       // 数据库ID
  meterID: string;
  fault: string;
  meterTypeID: number;
  typeName: string;
  location: string;
  type: number;
  status: number;
  isRead: number;
  messageDate: number;
  messageDateString: string;
  companyName: string;
  companyID: number;
}

export interface MeterAlarm {
  type: number;           // 0 故障  1 渗漏
  meterID: string;
  typeName: string;
  meterTypeID: number;
  fault: string;
  reportTime: string;
  companyName: string;
}

export interface Meter {
  id: number;                   // 数据库ID
  deleteState: number;
  meterID: string;              // 设备ID
  meterTypeID: number;
  typeName: string;             // 设备类型名称
  longitude: number;            // 维度
  latitude: number;             // 经度
  country: string;              // 国家
  province: string;             // 省份
  city: string;                 // 城市
  address: string;              // 地址
  life: number;                 // 寿命
  cycle: number;                // 周期
  mqttType: string;
  maxReading: number;           // maxReading
  routeBMaxReading: number;
  installDate: string;          // 安装日期
  parentMeterID: string;        // 父级设备ID
  parentMeterEntityID: string;  // 父级设备数据库ID
  ownUserID: number;            // 设备拥有者数ID
  ownUserName: string;          // 设备拥有者用户名
  installUserID: string;        // 设备安装者数ID
  installUserName: string;      // 设备安装者用户名
  hasChildren: boolean;
  meterCostName: string;
  expireDate: string;           // 到期时间
  nextMeterCostName: string;
  nextMeterCostDate: string;
  companyName: string;
  companyID: number;
  buildNo: string;
  reading: number;              // 读数
  usage: number;
  bRouteID: string;
  bRouteSecret: string;
  subMeterTypeIndex: number;
  networkName: string;
  pulseTypeMeterID: string;
  pulseVaule: string;
  moduleId: string;
  moduleVersion: string;
  meterVersion: string;
  connetcMeterID: string;
  connectFactor: number;
  readPowerLine: boolean;
  readPowerLineFrequence: number;
  diagnosticInformation: string;
  isExternalDeviceAutoRead: boolean;
  externalDeviceAutoReadMinute: string;
  externalDeviceAutoReadParam: string;
  powerPlantId: string;
  useStablePassword:boolean
}
export interface RsNetwork {
  id: number;
  name: string;
  startBaudRate: number;
  endBaudRate: number;
  startIndex: number;
  endIndex: number;
  baudRate: number;
  rsNetworkMeters: RsNetworkMeter[];
  masterMeterId: string
}

export interface RsNetworkMeter {
  id: number;
  rsNetworkId: number,
  rsNetworkName: string;
  masterMeter: Meter;
  meter: Meter;
  index: number;
  hasChildren: boolean;
  baudRate: number;
  setting: string;
  check0: boolean;
  check1: boolean;
  check2: boolean;
  check3: boolean;
  check4: boolean;
  check5: boolean;
  check6: boolean;
}
export interface Address {
  id: number;
  longitude: number;  // 纬度
  latitude: number;   // 经度
  country: string;    // 国家 
  province: string;   // 省份
  city: string;       // 城市
  detail: string;     // 详细地址
  buildNos: BuildNo[];
  userCount: number;
  meterCount: number;
  usage: number;
  cost: number;
}
export interface BuildNo {
  no: string;
  meters: Meter[];
  users: User[];
}
export interface Leakage {
  id: number;
  time: string;         // 时间
  describe: string;   // 描述
  quantity: number;     // 漏水量
  meter: Meter;     // 设备类型
}
/**
 * 公司的基本结构
 *
 * @export
 * @interface Company
 */
export interface Company {
  id: number;                 // 序列
  deleteState: number;        // 是否删除
  name: string;               // 公司名称
  logo: string;               // 公司图标
  address: string;            // 公司地址
  phone: string;              // 公司电话
  email: string;              // 公司邮箱
  webURL: string;             // 公司官网
  zone: string;               // 时区
  messageDate: number;        // 消息日期
  paymentDate: number;        // 结账日期
  parentCompanyName: string;
  parentCompanyID: number;
  leakage: string;
  leakage1: string;
  leakage2: string;
  leakage3: string;
  leakage4: string;
}
export interface Fireware {
  name: string;           // 名字
  id: number;
  url: string;            // url
  remark: string;         // 备注
  companyName: string;
  companyID: number;
  version: string;        // 版本
  meterTypeName: string;  // 名字
  meterTypeID: number;    // meterTpye ID
  note: string;
  createDate: string;
  module: string;
  firmwareFileSize: number;
  firmwareType: string;
}

export interface SimplifyMeter {
  meterID: string;
  meterTypeID: number;
}

export interface PowerConditionerTableData {
  index: string;
  content: string;
  data: string;
  lastTime: string;
  responseCode: string;
}

export interface SlaveControl {
  meterID: string,
  UnitNO: string,
  NetworkName: string,
  Command: string,
  ManualCommand: string,
}



export interface RsNetworkMeterCheck {
  checkArray: boolean[]
}
export interface NetworkData {
  i: number;
  name: string;
  command: string;
  response: string;
  unit: string;
  LastReportTime: string;
  LastReportTimestamp: number;
  count: string,
}

export interface ChartItem {
  title: string,
  type: number,
  left: boolean,
  check: boolean,
  unit: string
}

export interface MeterChartDatas {
  leftDatas: MeterChartData[]
  rightDatas: MeterChartData[]
  xDatas: string[]
  leftUnit: string,
  rightUnit: string,
  leftName: string,
  firstLeftName: string,
  letfTitleArray: string[];
  rightName: string,
}

export interface MeterChartData {
  name: string,
  yDatas: number[]
  unit: string,
}
export interface Echartlegend {
  data: string[]
}
export interface ModelConfig {
  commands: ModelConfigCommand[]
}
export interface ModelConfigCommand {
  type: number;
  // datas: ModelConfigData[];
  commands: ModelConfigData[];
  baudRates: string[];
  modelIndexs: string[]
}
export interface ModelConfigData {
  index: number;
  command: string;
  startAddress: string;
  paramNumber: number
}
export interface ElectricRecordDay {
  index: number;
  label: string;
  command: string;
  count: number
  startTimestamp: number
  endTimestamp: number
}

export interface MeterVersionInfomation {
  meterId: string;
  moduleId: string;
  moduleBootLoaderVersion: string;
  moduleMainFirmwareVersion: string;
}

export interface Device {
  class: string;
  className: string;
  deviceId: string;
  status: string;
  inUse: string;
}


export interface FirewareType{
  id:number;
  type:string;
  translateType:string;
}